import { connect } from 'react-redux';
import SignInAdmin from './signInAdmin';
import { impersonateUser } from '../../store/user/actions';
import { IAppState } from '../../store/types';

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.user.loading,
  isAuthenticated: state.user.isAuthenticated,
});

const mapDispatchToProps = {
  impersonateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInAdmin)
